import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ImageService } from '../../../../services/image/image.service';
import { ValueFirstAgencyService } from '../../services/value-first-agency.service';

@Component({
  selector: 'vfa-welcome-step',
  templateUrl: './welcome-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VfaWelcomeStep {
  readonly onboarding = inject(ValueFirstAgencyService);
  readonly imageService = inject(ImageService);

  selected(index: number): boolean {
    return this.onboarding.draft().pick === index;
  }

  choose(index: number): void {
    this.onboarding.selectPick(index);
  }

  start(): void {
    void this.onboarding.finish('start');
  }

  skip(): void {
    void this.onboarding.finish('skip');
  }

  startLabel(): string {
    const brand = this.onboarding.draft().createdBrands[this.onboarding.draft().pick];
    return brand ? `Start with ${brand.name} →` : 'Go to dashboard →';
  }

  domainLabel(domain: string): string {
    return domain || 'Added manually';
  }
}
